<div>
    <div class="mb-3">
      <label for="username" class="form-label">Username</label>
      <input [(ngModel)]="username" type="text" class="form-control" name="username" disabled>
    </div>
    <div class="mb-3">
        <label for="name" class="form-label">Name</label>
        <input [(ngModel)]="name" type="text" class="form-control" name="name">
      </div>
    <div class="mb-3">
      <label for="password" class="form-label">Password *</label>
      <input [(ngModel)]="password" type="password" class="form-control" name="password" [ngClass]=" {'validated': password.length >= 8, 'not-validated' : password.length < 8 }">
    </div>
    <div class="remoark">* is required, password has a minimum length of 8 characters</div>
    <button (click)="save()" class="btn btn-primary">Save</button>
    <button *ngIf="pageId != 1" class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#removeModal">Remove</button>
    <button (click)="cancel()" class="btn btn-primary">Cancel</button>
</div>

<!-- Modal -->
<div class="modal fade" id="removeModal" tabindex="-1" aria-labelledby="removeModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="removeModalLabel">Delete user '{{name}}'</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Do you really want to remove the user '<span style="font-weight: bold;">{{name}}</span>' ?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="delete()" data-bs-dismiss="modal">Remove</button>
      </div>
    </div>
  </div>
</div>